import createApiInstance from '@core/utils/api/custom.instance';

// 401(세션 만료)은 custom.instance 응답 인터셉터가 refresh 재시도 후 commonLogout 으로 처리한다.
export function makeProjectAxios(){
    // client_id 기본 파라미터는 죽은 계약이라 제거 — 백엔드(projects_bp)는 어디서도 읽지 않고
    // 다원청 접근제어는 서버측 DashboardViewer ACL 이 담당한다 (2026-09-01 의도 규명).
    return createApiInstance('projects');
}
